import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DatosBanco } from 'app/models/datos-banco';
import { IboxtoolsItem } from 'app/models/iboxtools-item';
import { ConfigDataService } from '../../../services/config-data.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DatosBancosService } from '../../../services/datos-bancos.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacionComponent } from '../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../components/shared/dialog-procesando/dialog-procesando.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErroresService } from '../../../core/services/errores.service';
import {MyValidations} from '../../../utils/my-validations';
import { GruposLiquidacionService } from '../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../core/services/moment-set.service';

@Component({
  selector: 'app-datos-banco',
  templateUrl: './datos-banco.component.html',
  styleUrls: ['./datos-banco.component.css']
})
export class DatosBancoComponent implements OnInit, OnChanges {

  @Input() legajo;
  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;

  banco: any;
  form: FormGroup;
  datosBancariosList: any[];
  cortarRegistro: boolean = false;

  constructor(private configDataSrv: ConfigDataService, 
              private datosBancosService: DatosBancosService, 
              private fb: FormBuilder, 
              private dialog: MatDialog, 
              private snackBar: MatSnackBar, 
              private erroresService: ErroresService,
              private gruposLiquidacionService: GruposLiquidacionService,
              private momentService: MomentSetService) { }

  bancoList: any;
  monedasList: any;
  pagoList: any;
  ingreso: any;

  MensajeError: string;
  disabledEditing: boolean = true;
  eliminando: boolean;
  eliminacionInvalida: boolean;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  submitted = false;
  bancosInvalida: boolean = false;

  datosBancariosHistoryList: any;
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  public cargaCompleta = false;

  get registerFormControl() { return this.form?.controls; }

  ngOnInit(): void
  {
    this.configDataSrv.GetBancos()
      .subscribe(
        data => {
          this.bancoList=data["Bancos"];
          this.monedasList=data["Monedas"];
          this.pagoList = data["ViaPago"];
        },
        error => {
          console.log(error);
        });

    this.configurarValidadores();
    this.obtenerActual();
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Datos Bancarios")) this.permisoEdicion = true;
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      personal: ['', Validators.required],
      cbu: ['', Validators.required],
      viaPago: ['', Validators.required],
      banco: ['', Validators.required],
      moneda: ['', Validators.required],
      cuentaBancaria: ['', Validators.required],
      alias: [''],
    });
  }

  ngOnChanges(changes: SimpleChanges)
  {
  }

  setearForm(datosBanco: DatosBanco)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(datosBanco?.id);
      this.form.controls['personal'].setValue(datosBanco?.personal);
      this.form.controls['desde'].setValue(new Date(datosBanco?.desde));
      this.form.controls['hasta'].setValue(new Date(datosBanco?.hasta));
      this.form.controls['cbu'].setValue(datosBanco?.cbu);
      this.form.controls['cuentaBancaria'].setValue(datosBanco?.cuentaBancaria);
      this.form.controls['banco'].setValue(datosBanco?.banco);
      this.form.controls['moneda'].setValue(datosBanco?.moneda);
      this.form.controls['viaPago'].setValue(datosBanco?.viaPago);

      if (datosBanco != null && datosBanco.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.banco))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.datosBancosService.delete(this.banco.id).subscribe(
            response =>
            {
              this.snackBar.open("Dato Bancario eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              this.obtenerActual();
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.banco))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['desde'].disable();
        $this.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let datoBancario = this.datosBancariosList.find(d => d.id == index);
    this.banco = datoBancario;
    this.setearForm(this.banco);
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    if (this.datosBancariosList != undefined)
    {
      if (this.banco.id == 0 && this.datosBancariosList.length == 0)
      {
        this.banco = null;
      }
      else if (this.banco.id == 0 && this.datosBancariosList.length > 0)
      {
        this.banco = this.datosBancariosList[0];
      }
    }
    else
    {
      this.banco = null;
    }

    this.setearForm(this.banco);
    this.deshabilitarEdicion();
  }

  async OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.form.getRawValue();

      let datosBan: DatosBanco = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        cbu: formulario.cbu,
        viaPago: formulario.viaPago,
        banco: formulario.banco,
        moneda: formulario.moneda,
        cuentaBancaria: formulario.cuentaBancaria,
        alias: formulario.alias
      };

      this.datosBancosService.save(datosBan, this.cortarRegistro).subscribe(
        datoBancario =>
        {
          datoBancario.desde = this.momentService.convertDateServer(datoBancario.desde);
          datoBancario.hasta = this.momentService.convertDateServer(datoBancario.hasta);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Dato bancario guardado", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial();
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //datoBancario.desde = datoBancario.desde.replace('Z', '');
          this.setearForm(datoBancario);
        },
        error =>
        {
          dialogProcesandoRef.close();
          if (error.status == 400)
          {
            this.bancosInvalida = true;
            
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      let fdesde = new Date().toString();
      let fecha = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
      if (fecha != undefined){
        fdesde = fecha.desde
      }
      let datosBanco: DatosBanco = { id: 0, personal: this.personalId, desde: fdesde, hasta: new Date("2999-12-31T23:59:59").toString(), banco: 0, cbu: "", cuentaBancaria: "", moneda: 0, viaPago: 0, alias:"" };
      this.banco = datosBanco;
      this.setearForm(datosBanco);
    
      this.habilitarEdicion();
      this.form.controls['id'].setValue(0);
      this.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['hasta'].disable();
      });
    }
  }

  add()
  {
    this.OnNewChange(true);
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarForm(false);
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarForm(true);
  }

  private volverAtras()
  {
    this.MensajeError = "";
    this.datosBancariosHistoryList = [];
    this.datosBancariosList = [];
    this.habilitarForm(false);
  }

  private obtenerHistorial()
  {
    this.datosBancosService.getHistoryByPersonalId(this.personalId).subscribe(
      datosBancarios =>
      {
        datosBancarios.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.datosBancariosHistoryList = [];
        
        if (datosBancarios.length > 0)
        {
          datosBancarios.forEach(d =>
          {
            let item = new IboxtoolsItem(d);
            this.datosBancariosHistoryList.push(item);
          });

          this.datosBancariosList = datosBancarios;

        }
        else
        {
          this.setearForm(null);
          this.banco = null;
          this.datosBancariosList = [];
        }

      },
      error =>
      {
        console.log(error);
      });
  }

  private obtenerActual()
  {
    let fechaHoy = new Date();
    this.datosBancosService.getByPersonalId(this.personalId).subscribe(
      datosBancarios =>
      {
        datosBancarios.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        
        if (datosBancarios.length > 0)
        {
          this.banco = datosBancarios.find(f=> Date.parse(f.desde) <= fechaHoy.getTime() &&
                                               Date.parse(f.hasta) >= fechaHoy.getTime());
          
          if (this.banco == null) this.banco = datosBancarios[0];
          this.obtenerHistorial();
        }
        else
        {
          this.banco = null;
        }
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    //TODO. Revisar
    if (this.form.get("banco").value == 0)
    {
      this.form.get("banco").setErrors({ 'invalid': true });
    }

    if (this.form.get("viaPago").value == null)
    {
      this.form.get("viaPago").setErrors({ 'invalid': true });
    }

    if (this.form.get("moneda").value == 0)
    {
      this.form.get("moneda").setErrors({ 'invalid': true });
    }

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    let hoy = new Date()
    
    let fingreso = new Date(this.ingreso.desde).toDateString();
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      //Valida que la fecha desde no sea anterior a la fecha de ingreso
      this.form.get("desde").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
      
    }

    if (this.form.valid)
    {
      return true;
    }
    else
    {
      this.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }

}

